export default "__VITE_ASSET__26e3dc88__"